// ---------------------------------------------------------------------------
// GOALSTAV — centralized site content
// Texts, photos, services, projects, locations and FAQs live here so the
// client can adjust content without touching components.
// ---------------------------------------------------------------------------

export const company = {
  name: "GOALSTAV",
  legalName: "Goalstav s.r.o.",
  tagline: "Rekonstrukce · Fasády · Zednické práce",
  owner: "Jiří Běha",
  ownerRole: "Jednatel společnosti GOALSTAV s.r.o.",
  phone: "+420 776 589 281",
  phoneHref: "tel:+420776589281",
  email: "goalstav@email.cz",
  emailHref: "mailto:goalstav@email.cz",
  ico: "07921420",
  city: "Plzeň",
  claim: "Poctivá práce je vidět na výsledku.",
};

export const navigation = [
  { label: "Služby", href: "/#sluzby" },
  { label: "Realizace", href: "/#realizace" },
  { label: "Jak pracujeme", href: "/#jak-pracujeme" },
  { label: "O nás", href: "/#o-nas" },
  { label: "Kontakt", href: "/#kontakt" },
];

export const services = [
  {
    id: "zatepleni",
    number: "01",
    title: "Zateplování a fasády",
    short: "Zateplovací systémy a fasádní úpravy rodinných i bytových domů.",
    description:
      "Zateplení je nejúčinnější způsob, jak snížit tepelné ztráty domu. Pracujeme s certifikovanými systémy renomovaných výrobců a zakládáme si na precizní přípravě podkladu a čisté práci.",
    works: [
      "zateplení bytových i rodinných domů",
      "silikonové a silikátové fasády",
      "opravy a renovace fasád",
      "kompletní dodávka včetně lešení",
    ],
    image: "./images/fasada-zluty-dum.jpg",
    imageAlt: "Zateplení rodinného domu — dokončená realizace",
    link: "/sluzby/zatepleni",
  },
  {
    id: "rekonstrukce",
    number: "02",
    title: "Rekonstrukce bytů, bytových jader a rodinných domů",
    short: "Kompletní rekonstrukce bytů, bytových jader a rodinných domů.",
    description:
      "Zajistíme rekonstrukci bytu, bytového jádra i rodinného domu od bouracích prací až po finální dokončovací práce. Pracujeme s citem pro detail, aby byl výsledek přesný, rovný a estetický.",
    works: [
      "bourací a přípravné práce",
      "zdění příček a stavební úpravy",
      "koupelny, obklady a dlažby",
      "podlahy, štuky, malby a finální dokončovací práce",
    ],
    image: "./images/rekonstrukce-koupelna.jpg",
    imageAlt: "Dokončené sociální zázemí po rekonstrukci",
    link: "/sluzby/rekonstrukce",
  },
  {
    id: "zednicke-prace",
    number: "03",
    title: "Zednické práce",
    short:
      "Provádíme zednické práce při rekonstrukcích i samostatných stavebních úpravách pro byty, rodinné domy i bytové domy.",
    description:
      "Provádíme zednické práce při rekonstrukcích i samostatných stavebních úpravách pro byty, rodinné domy i bytové domy. Ke každé zakázce přistupujeme individuálně a dbáme na čistotu provedení.",
    works: [
      "opravy zdiva, omítek a betonových konstrukcí",
      "schodiště, sokly a venkovní stavební úpravy",
      "zdění příček a stavební úpravy",
      "dokončovací zednické práce",
    ],
    image: "./images/zednicke-pruchod.jpg",
    imageAlt: "Zrekonstruovaný průjezd domu se zděnou stěnou",
    link: "/sluzby/zednicke-prace",
  },
];

export const caseStudy = {
  eyebrow: "Vybraná realizace",
  title: "Nová fasáda bytového domu",
  location: "Plzeň",
  mainImage: "./images/fasada-bytovy-dum-po.webp",
  mainImageAlt: "Dokončená fasáda bytového domu po rekonstrukci",
  progressImage: "./images/fasada-pred-rekonstrukci.jpg",
  progressImageAlt: "Původní stav fasády před rekonstrukcí",
  detailImage: "./images/fasada-po-rekonstrukci.jpg",
  detailImageAlt: "Dokončená fasáda bytového domu po rekonstrukci",
  sections: [
    {
      label: "Zadání",
      text: "Obnova vzhledu staršího bytového domu a nová fasádní úprava.",
    },
    {
      label: "Řešení",
      text: "Příprava podkladu, lokální opravy zdiva, nové vrstvy a finální povrchová úprava.",
    },
    {
      label: "Výsledek",
      text: "Čistý a sjednocený vzhled domu s odolným povrchem.",
    },
  ],
};

export const beforeAfter = {
  title: "Rozdíl je vidět na první pohled.",
  before: "./images/srovnani-pred.jpg",
  after: "./images/srovnani-po.jpg",
  caption: "Fasáda bytového domu · Plzeň",
};

export const galleryCategories = [
  "Vše",
  "Fasády",
  "Zateplení",
  "Rekonstrukce",
  "Zednické práce",
];

export const gallery = [
  { src: "./images/fasada-mestsky-dum.jpg", category: "Fasády", title: "Fasáda městského domu", note: "Dokončená realizace" },
  { src: "./images/fasada-bily-dum.jpg", category: "Fasády", title: "Fasáda rodinného domu", note: "Dokončená realizace" },
  { src: "./images/fasada-rodinny-dum.jpg", category: "Fasády", title: "Fasáda rodinného domu", note: "Dokončená realizace" },
  { src: "./images/fasada-detail-sokl.jpg", category: "Fasády", title: "Detail fasády a soklu", note: "Detail provedení" },
  { src: "./images/fasada-novostavba-seda.jpg", category: "Zateplení", title: "Zateplená fasáda", note: "Dokončená realizace" },
  { src: "./images/fasada-zluty-dum.jpg", category: "Zateplení", title: "Zateplení rodinného domu", note: "Dokončená realizace" },
  { src: "./images/fasada-zluty-dum-2.jpg", category: "Zateplení", title: "Zateplená fasáda rodinného domu", note: "Dokončená realizace" },
  { src: "./images/rekonstrukce-koupelna.jpg", category: "Rekonstrukce", title: "Rekonstrukce sociálního zázemí", note: "Dokončená realizace" },
  { src: "./images/rekonstrukce-chodba.jpg", category: "Rekonstrukce", title: "Rekonstrukce chodby", note: "Dokončená realizace" },
  { src: "./images/rekonstrukce-schodiste.jpg", category: "Rekonstrukce", title: "Nové schodiště", note: "Dokončená realizace" },
  { src: "./images/rekonstrukce-interier.jpg", category: "Rekonstrukce", title: "Interiér po rekonstrukci", note: "Dokončená realizace" },
  { src: "./images/rekonstrukce-obklad.jpg", category: "Rekonstrukce", title: "Dřevěný obklad stěn", note: "Detail provedení" },
  { src: "./images/rekonstrukce-podlaha.jpg", category: "Rekonstrukce", title: "Nová podlaha", note: "Průběh realizace" },
  { src: "./images/rekonstrukce-koberec.jpg", category: "Rekonstrukce", title: "Zátěžová podlahová krytina", note: "Dokončená realizace" },
  { src: "./images/zednicke-pruchod.jpg", category: "Zednické práce", title: "Průjezd domu", note: "Dokončená realizace" },
];

export const brands = ["Weber", "Baumit", "Cemix", "Knauf", "Caparol"];

export const processSteps = [
  {
    number: "01",
    title: "Kontakt a základní informace",
    text: "Popíšete nám projekt a případně pošlete fotografie.",
  },
  {
    number: "02",
    title: "Prohlídka nebo zaměření",
    text: "Zakázku projdeme a ověříme skutečný stav.",
  },
  {
    number: "03",
    title: "Návrh řešení a nabídka",
    text: "Doporučíme vhodný postup a připravíme cenovou nabídku.",
  },
  {
    number: "04",
    title: "Realizace",
    text: "Práce provedeme podle dohodnutého rozsahu a harmonogramu.",
  },
  {
    number: "05",
    title: "Kontrola a předání",
    text: "Výsledek společně projdeme a dokončíme poslední detaily.",
  },
];

export const whyUs = [
  {
    label: "Jasná cenová nabídka",
    text: "Před zahájením prací si odsouhlasíme rozsah i cenu. Bez překvapení.",
  },
  {
    label: "Precizní provedení",
    text: "Dbáme na kvalitní přípravu, přesné provedení a dlouhou životnost.",
  },
  {
    label: "Přímá komunikace",
    text: "Po celou dobu jednáte přímo s odpovědnou osobou.",
  },
  {
    label: "Ověřené materiály",
    text: "Používáme kvalitní materiály od prověřených výrobců.",
  },
];

export const locations = [
  "Plzeň",
  "Klatovy",
  "Domažlice",
  "Rokycany",
  "Tachov",
  "Stříbro",
  "Dobřany",
];

export const faqs = [
  {
    q: "Jak probíhá úvodní nacenění?",
    a: "Stačí nám poslat stručný popis zakázky, ideálně s fotografiemi. Zakázku projdeme, případně domluvíme prohlídku na místě a připravíme cenovou nabídku.",
  },
  {
    q: "Je možné poslat fotografie zakázky?",
    a: "Ano, fotografie nám pomohou s úvodním posouzením. Můžete je přiložit přímo do poptávkového formuláře nebo poslat e-mailem.",
  },
  {
    q: "Kde všude realizujete?",
    a: "Nejčastěji realizujeme zakázky do 50 km od Plzně – například Klatovy, Domažlice, Rokycany, Tachov, Stříbro nebo Dobřany. Větší projekty po domluvě i mimo tento okruh.",
  },
  {
    q: "Provádíte i menší zednické práce?",
    a: "Ano, kromě větších zakázek provádíme i drobné opravy a menší stavební úpravy podle konkrétního projektu.",
  },
  {
    q: "Zajišťujete kompletní rekonstrukce?",
    a: "Ano, rekonstrukce bytů, bytových jader i rodinných domů zajistíme od bouracích prací až po finální dokončovací práce.",
  },
  {
    q: "Jak dlouho realizace obvykle trvá?",
    a: "Délka závisí na rozsahu zakázky a stavu objektu. Přesnější termín stanovíme po prohlídce.",
  },
  {
    q: "Jaké materiály používáte?",
    a: "Pracujeme s ověřenými materiály renomovaných výrobců – například Weber, Baumit, Cemix, Knauf nebo Caparol. Konkrétní systém volíme podle stavu podkladu a požadovaného výsledku.",
  },
  {
    q: "Je nabídka závazná?",
    a: "Úvodní nabídka je nezávazná. Rozsah prací i cenu si společně odsouhlasíme před zahájením zakázky.",
  },
];

export const serviceOptions = [
  "Zateplení a fasáda",
  "Rekonstrukce bytu / bytového jádra",
  "Rekonstrukce rodinného domu",
  "Zednické práce",
  "Jiné",
];
